import React from 'react';
import './ScorecardIcons.styl';
import CommentIcon from 'components/pure/utils/icon/CommentIcon';
import classNames from 'classnames';

const ScorecardCommentIcon = ({shrink = false}) => (
  <div className="scorecard-img-wrapper">
    <CommentIcon className={classNames('comment', {shrink})} />
  </div>
);

export default ScorecardCommentIcon;
